<template lang="pug">
.section
  .section-header
    h1 {{ $t("ui.domain_available") }}
  .section-body
    .row
      .col-12
        .card.mb-0
          .card-header
            .row.w-100
              .form-group.col-md-3.col-2.mb-1
                b-input-group(size="sm")
                  b-input-group-text(slot="prepend")
                    span {{ $t('ui.domain_group') }}
                  b-form-select(v-model="domainGroup" size="sm" @change="getDomainAvailableList(true)")
                    option(value="") {{ $t('ui.all') }}
                    option(value="MEMBER") {{ $t('ui.member') }}
                    option(value="AFFILIATE") {{ $t('ui.affiliate') }}
              .form-group.col-md-3.col-2.mb-1
                b-input-group(size="sm")
                  b-input-group-text(slot="prepend")
                    i.fa.fa-search
                  DebounceInput(autofocus type="text" v-model="domainName" :placeholder="$t('ui.domain_name')" @enter="getDomainAvailableList(true)" size="sm")
              .form-group.col-md-6.col-8.mb-1
                SubmitButton(
                  :loading="loading"
                  icon="fa fa-search"
                  :text="$t('ui.search')"
                  type="button"
                  @click="getDomainAvailableList(true)"
                  variant="primary"
                  size="sm"
                )
          .card-body
            .row
              .col-10.mb-1
                b-pagination.float-left(
                  size="sm"
                  hide-ellipsis
                  :total-rows="totalRow"
                  :per-page="getPageSize"
                  v-model="currentPage"
                  @input="changedPage($event)")
              .col-2.mb-1
                b-input-group(:prepend="$t('ui.page_size')" size="sm")
                  b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize" size="sm")
              .col-12
                .clusterize-scroll.table-responsive
                  table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
                    thead.thead-light
                      tr
                        th.text-center(width="4%")
                          span #
                        th(width="15%")
                          span(:ttile="$t('ui.domain_id')") {{ $t('ui.domain_id') }}
                        th(width="10%")
                          span(:title="$t('ui.domain_name')") {{ $t('ui.domain_name') }}
                        th.text-center(width="10%" @click="sortOrder('domain_group')")
                          span(:title="$t('ui.domain_group')") {{ $t("ui.domain_group") }}
                          .float-right
                            i(:class="changeSortKey('domain_group')")
                        th.text-right(width="10%" @click="sortOrder('price')")
                          span(:title="$t('ui.price')") {{ $t("ui.price") }}
                          .float-right
                            i(:class="changeSortKey('price')")
                        th.text-right(width="10%" @click="sortOrder('created_by')")
                          span(:title="$t('ui.created_by')") {{ $t("ui.created_by") }}
                          i(:class="changeSortKey('created_by')")
                        th.text-right(width="10%" @click="sortOrder('created_date')")
                          span(:title="$t('ui.created_date')") {{ $t("ui.created_date") }}
                          .float-right
                            i(:class="changeSortKey('created_date')")
                    tbody.clusterize-content
                      tr(v-if="domainList.length == 0")
                        td(colspan="10").text-center
                          span {{ $t('message.no_data_available') }}
                      tr(v-for="(item, index) in domainList")
                        td.text-center
                          span(:title="((currentPage - 1) * getPageSize + index + 1)") {{ ((currentPage - 1) * getPageSize + index + 1) }}
                        td
                          span(:title="item.domain_id") {{ item.domain_id }}
                        td
                          span(:title="item.domain_name") {{ item.domain_name }}
                        td.text-center
                          span(:title="item.domain_group") {{ item.domain_group }}
                        td.text-right
                          span(:title="$n(item.price, 'currency')") {{ item.price ? $n(item.price, 'currency') : "-" }}
                        td.text-right
                          span(:title="item.created_by") {{ item.created_by }}
                        td.text-right
                          span(:title="$moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss') }}
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {  
    SubmitButton,
    DebounceInput
  },
  data: () => ({
    loading: false,
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    currentPage: 1,
    totalRow: 0,
    sortKey: "domain_name",
    sortType: "asc",
    domainGroup: "",
    domainName: "",
    domainList: []
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    isOperator() {
      return [2].includes(this.$store.getters.accountType);
    },
    isEditAccess() {
      return this.$helpers.showActionButton("e_domainavailable");
    }
  },
  mounted: function() {
    this.getDomainAvailableList(true);
  },
  methods: {
    sortOrder(key) {
      if (this.sortKey == key)
        this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey = key;
        this.sortType = 'asc';
      }

      this.getDomainAvailableList(true);
    },
    changeSortKey(key) {
      if (this.sortKey != key)
        return 'fas fa-sort';
      else if (this.sortKey == key && this.sortType == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey == key && this.sortType == 'desc')
        return 'fa fa-sort-down';
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentPage = 1;
      this.getDomainAvailableList(true);
    },
    changedPage: function(pageNo) {
      this.currentPage = pageNo;
      this.getDomainAvailableList();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    },
    getDomainAvailableList: function(isSearch, evt) {
      let url = config.domainDefaultAvailableList2();

      if (isSearch) this.currentPage = 1;

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        module: this.domainGroup,
        domain_name: this.domainName,
        sort_key: this.sortKey,
        sort_type: this.sortType,
        page_number: this.currentPage,
        page_size: this.getPageSize
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;

              if (this.feedback.success == true) {
                this.domainList = response.data.dt;
                this.totalRow = this.domainList.length > 0 ? this.domainList[0].totalrows : 0;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    }
  }
};
</script>